<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData"   :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="configcode"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'convertconfigdetail',query: {platformcode: record.platformcode,configcode:record.configcode,rangecode:record.rangecode}}">覆盖</router-link>
                <router-link class="tableLink" :to="{path:'detailconfigdetail',query: {platformcode: record.platformcode,configcode:record.configcode,rangecode:record.rangecode}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'editconfigdetail',query: {platformcode: record.platformcode,configcode:record.configcode,rangecode:record.rangecode}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

            <template slot="platformcode" slot-scope="text">
                <span>{{ searchP.platformlist.find(item=>{return item.value == text}).text }}</span>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    
    {
        title: "平台名称",
        dataIndex: "platformcode",
        align: "center",
        scopedSlots: { customRender: 'platformcode' },
        width:100,
        ellipsis: true,
    },
    {
        title: "目录",
        dataIndex: "catalogname",
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "配置编码",
        dataIndex: "configcode",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "配置名称",
        dataIndex: "configname",
        align: "center",
        width:200,
        ellipsis: true,
    },

    {
        title: "层级编码",
        dataIndex: "rangecode",
        align: "center",
        width:200,
        ellipsis: true,
    },
    
    {
        title: "本地版本号",
        dataIndex: "lversion",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "服务器版本号",
        dataIndex: "sversion",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'operation' },
    }
];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{
                platformcode:'',
                keyword:'',
                platformlist:[]
            },
            platforms:[],
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "cloudconfig/delconfig",
                params: {
                    platformcode: item.platformcode,
                    configcode:item.configcode,
                    rangecode:item.rangecode,
                    operateuser:this.G.getCurrentUser().username,
                }
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                platformcode:that.searchP.platformcode,
                configcode:that.searchP.configcode,
                tabIndex:that.searchP.tabIndex,
                rangecode:that.searchP.rangecode,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "cloudconfig/queryconfigdetailpage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

